import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tarifasAlertas'
})
export class TarifasAlertasPipe implements PipeTransform {

  transform(reactivos: any[], searchText: string): unknown {
    if (!reactivos) return [];
    if (!searchText) return reactivos;
  
    searchText = searchText.toLowerCase();
  
    return reactivos.filter( it => {
      return it.Nombre.toLowerCase().includes(searchText)
      || it.SPN.toLowerCase().includes(searchText);
    });
  }
}
